import { Outlet } from "react-router"
import { Header } from "."

export function CustomerRoot(): JSX.Element {
  return (
    <div>
      <Header />
      
      <Outlet />
       
    </div>
  )
}
